import React, { Component } from 'react'
import { connect } from "react-redux";
import { Helmet } from 'react-helmet-async';
import { Button } from 'reactstrap';
import MUIDataTable from "mui-datatables";
import IconButton from '@mui/material/IconButton';
import MatButton from '@mui/material/Button';

// intl messages
import IntlMessages from 'Util/IntlMessages';
// page title bar
import PageTitleBar from 'Components/PageTitleBar/PageTitleBar';
// app config
import AppConfig from 'Constants/AppConfig';

import ConfirmationDialog from "Routes/common/ConfirmationDialog";
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import {
   allVisitors,   
   deleteVisitors,
   fetchVisitors,
} from 'Actions';

// rct card box
import RctCollapsibleCard from 'Components/RctCollapsibleCard/RctCollapsibleCard';

import AddItem from './component/addform';
import UpdateItems from './component/editform';

class travelform extends Component {
   
    constructor(props) {
      
      super(props);
      this.confirmationDialog = React.createRef();
         this.state = {
            viewdiv:true,
            adddiv:false,
            vdiv:false,
            checkoutdate:'',
            checkindate:'',
            ssstartdate:'',
            ssenddate:'',
            name:'',
            mobile:'',
            eid:'',
         
         };    

    
         this.onBackSection = this.onBackSection.bind(this);
         this.deleteForm = this.deleteForm.bind(this);
         this.editAssessment = this.editAssessment.bind(this);
    } 

    UNSAFE_componentWillMount() {
		this.props.allVisitors();
	}

    onAddSession() {
		this.setState({ 
         viewdiv:false,
         vdiv:false,
         adddiv:true,
      });
	}

    editAssessment(id){
            
      this.props.fetchVisitors(id).then((data) => { 
         var resdata=data.data;        

         this.setState({
            checkoutdate:resdata[0].cvd_checkoutdate,
            checkindate:resdata[0].cvd_checkindate,
            ssstartdate:resdata[0].cvd_sestartdate,
            ssenddate:resdata[0].cvd_seendstart,
            name:resdata[0].cvd_name,
            mobile:resdata[0].cvd_mobile,
            eid:resdata[0].cvdID,          
         });

         this.setState({ 
               viewdiv:false,
               adddiv:false,
               vdiv:true,
         });

      });
    }

      
    onBackSection() {
		this.setState({ 
         adddiv:false,
         viewdiv:true,
         vdiv:false,

       });
	}  
   

    deleteForm(data){
      this.data = data;
      this.confirmationDialog.current.openDialog();
    }

    deleteDataPermanent(popupResponse){
      
        if (popupResponse) {
          this.props.deleteVisitors(this.data);
          this.data = ""
        }
    }

    render() {
       const { match, visitorslist, loading } = this.props;
       const options = {
            filterType: 'dropdown',
            rowsPerPage: 50,
            responsive:'standard',
            rowsPerPageOptions: [50, 100, 150],
            selectableRowsHideCheckboxes: true,
        };

        const columns = [
            { name: "no", label: "NO" },
            { name: "name", label: "NAME" },
            { name: "chkin", label: "CHECK-IN DATE" },
            { name: "chkout", label: "CHECK-OUT DATE" },
            { name: "start", label: "START DATE" },
            { name: "end", label: "END DATE" },
            { name: "mobile", label: "MOBILE" },
            { name: "action", label: "ACTION" },
            { name: "action1", label: "ACTION1" },
          
        ];
        const tabledata=visitorslist.map((assmntval,idx) => {     
                     const ebtn=<IconButton className='text-info' onClick={ ()=>this.editAssessment(assmntval.cvdID)}><EditOutlinedIcon/></IconButton>;
                     const dbtn=<IconButton  className="text-danger" aria-label="Remove" onClick={ ()=>this.deleteForm(assmntval.cvdID)}  ><DeleteOutlineOutlinedIcon/></IconButton>;
               
                return {
                    no:idx+1,
                    name: assmntval.cvd_name,
                    chkin: assmntval.cvd_checkindate,
                    chkout:assmntval.cvd_checkoutdate,
                    start: assmntval.cvd_sestartdate,
                    end:assmntval.cvd_seendstart,
                    mobile: assmntval.cvd_mobile,
                    action: ebtn,
                    action1:dbtn,
                
                }
        });

 

       return (
          <div className="saas-dashboard">
             <Helmet>
                <title>Visiting Golfers | {AppConfig.appTitle}</title>
                <meta name="description" content="Travel" />
             </Helmet>
             <PageTitleBar title={<IntlMessages id="sidebar.visitgolfers" />} match={match} />
             
               {this.state.viewdiv && 
                  <div className="col-sm-12 col-lg-10">
                     <RctCollapsibleCard heading="List" fullBlock>
                        <MUIDataTable
                              title={<div><Button onClick={ ()=>this.onAddSession()} className="btn btn-outline-info"><i className="zmdi zmdi-plus-circle-o"></i>  Add Visitor</Button></div>}
                              data={tabledata}
                              columns={columns}
                              options={options} 
                        />   
                     </RctCollapsibleCard>
                  </div>
               }
               {this.state.adddiv && 
                 <AddItem onClick={this.onBackSection} />
               }

               {this.state.vdiv && 
                <UpdateItems onClick={this.onBackSection} data={this.state} />
                
               }

            <ConfirmationDialog
               ref={this.confirmationDialog}
               onConfirm={(res) => this.deleteDataPermanent(res)}
               data={'visitor'}
            />
                  
          </div>
       )
    }
 }

const mapStateToProps = ({ visitors }) => {
	const { visitorslist, loading } = visitors;
	return { visitorslist, loading };
}

export default connect(mapStateToProps, {
    allVisitors,
    deleteVisitors,
    fetchVisitors,
})(travelform); 